import { create } from "zustand";
import { PlacePrediction } from "@/components/locations/find-a-location/places-api";

type CachedSearch = {
  input: string;
  predictions: PlacePrediction[];
  timestamp: number;
};

type LocationSearchStore = {
  cache: Record<string, CachedSearch>;
  addToCache: (input: string, predictions: PlacePrediction[]) => void;
  cleanupCache: () => void;
};

const CACHE_DURATION = 24 * 60 * 60 * 1000; // 24 hours in milliseconds

export const useLocationSearchStore = create<LocationSearchStore>((set) => ({
  cache: {},
  addToCache: (input, predictions) =>
    set((state) => ({
      cache: {
        ...state.cache,
        [input]: {
          input,
          predictions,
          timestamp: Date.now(),
        },
      },
    })),
  cleanupCache: () =>
    set((state) => {
      const now = Date.now();
      const newCache = { ...state.cache };
      Object.keys(newCache).forEach((key) => {
        if (now - newCache[key].timestamp > CACHE_DURATION) {
          delete newCache[key];
        }
      });
      return { cache: newCache };
    }),
}));
